import * as yup from 'yup';
import { newPasswordSchema } from '../../auth';

const emailSchema = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required('Email is required')
    .email('Invalid email address'),
});

export const schema = newPasswordSchema.concat(emailSchema);
